export default __webpack_public_path__ + "static/media/crystl-white.bbfc82ce.svg";